import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Testimonial {
  id: number;
  name: string;
  role: string;
  company: string;
  image: string;
  alt: string;
  rating: number;
  testimonial: string;
  achievement: string;
}

const SuccessStories = () => {
  const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Jessica Martinez",
    role: "Senior Frontend Developer",
    company: "TechCorp Solutions",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_166ae88fa-1763293441010.png",
    alt: "Professional Hispanic woman with long dark hair in navy blazer smiling confidently at camera",
    rating: 5,
    testimonial: "public/assets/images/WeSkill_Logo-1768646176551.png transformed my career. The live classes and expert instructors helped me transition from junior to senior developer in just 8 months. The community support was invaluable!",
    achievement: "40% salary increase"
  },
  {
    id: 2,
    name: "Robert Thompson",
    role: "Data Scientist",
    company: "Analytics Pro",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f87887d2-1763295449035.png",
    alt: "Confident African American man in gray suit with glasses smiling professionally",
    rating: 5,
    testimonial: "The Data Science course exceeded my expectations. Real-world projects and personalized feedback from instructors made complex concepts easy to understand. Best investment in my career!",
    achievement: "Career transition success"
  },
  {
    id: 3,
    name: "Priya Sharma",
    role: "UX/UI Designer",
    company: "Creative Studios",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_19205d2aa-1763296356182.png",
    alt: "Young Indian woman with black hair in white shirt smiling warmly in bright office setting",
    rating: 5,
    testimonial: "The flexible schedule allowed me to learn while working full-time. The instructor's industry experience and practical assignments helped me build a portfolio that landed my dream job!",
    achievement: "Dream job secured"
  }];


  return (
    <section className="bg-transparent py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full mb-4 shadow-sm border border-white/20">
            <Icon name="ChatBubbleLeftRightIcon" size={20} variant="solid" className="text-primary" />
            <span className="text-sm font-semibold text-white">Success Stories</span>
          </div>
          <h2 className="font-headline text-3xl sm:text-4xl lg:text-5xl font-bold text-white drop-shadow-lg mb-4">
            Real Results from Real Learners
          </h2>
          


        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) =>
          <div
            key={testimonial.id}
            className="bg-white/10 backdrop-blur-md rounded-xl p-6 shadow-card hover:shadow-brand transition-all duration-300 border border-white/20">

              <div className="flex items-center space-x-4 mb-4">
                <div className="relative w-16 h-16 rounded-full overflow-hidden flex-shrink-0 border-2 border-white/30">
                  <AppImage
                  src={testimonial.image}
                  alt={testimonial.alt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="flex-1">
                  <h4 className="font-headline text-lg font-bold text-white drop-shadow-md">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-white/70">{testimonial.role}</p>
                  <p className="text-xs text-primary font-medium">{testimonial.company}</p>
                </div>
              </div>

              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) =>
              <Icon key={i} name="StarIcon" size={16} variant="solid" className="text-accent" />
              )}
              </div>

              <p className="text-white/80 leading-relaxed mb-4 drop-shadow-sm">
                "{testimonial.testimonial}"
              </p>

              <div className="flex items-center space-x-2 pt-4 border-t border-white/20">
                <Icon name="TrophyIcon" size={20} variant="solid" className="text-success" />
                <span className="text-sm font-semibold text-success">{testimonial.achievement}</span>
              </div>
            </div>
          )}
        </div>

        <div className="text-center mt-12">
          <div className="inline-flex items-center space-x-8 bg-white/10 backdrop-blur-md px-8 py-4 rounded-full shadow-card border border-white/20">
            <div className="text-center">
              <p className="text-3xl font-bold text-primary drop-shadow-md">98%</p>
              <p className="text-xs text-white/70">Completion Rate</p>
            </div>
            <div className="w-px h-12 bg-white/20"></div>
            <div className="text-center">
              <p className="text-3xl font-bold text-success drop-shadow-md">85%</p>
              <p className="text-xs text-white/70">Career Advancement</p>
            </div>
            <div className="w-px h-12 bg-white/20"></div>
            <div className="text-center">
              <p className="text-3xl font-bold text-accent drop-shadow-md">4.8/5</p>
              <p className="text-xs text-white/70">Average Rating</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default SuccessStories;